
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class LoginStatusIndicator extends Vue {
  get user() {
    return this.$store.state.authentication.currentUser;
  }
}
